export default "__VITE_ASSET__n7IS6A3b__"